var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("GetFormField")
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("get.LoyaltyExpense.FinanceCode")) + ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.FinanceCode))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("get.LoyaltyExpense.StatusId")) + ":")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.StatusId
                          ? _vm.$t("insert.active")
                          : _vm.$t("insert.passive")
                      )
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.LoyaltyExpense.title"),
                  active: ""
                }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Description,
                                "text",
                                "get.LoyaltyExpense.Description"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Representative,
                                "object",
                                "get.LoyaltyExpense.RepresentativeId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Customer,
                                "object",
                                "get.LoyaltyExpense.CustomerId"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Loyalty,
                                "object",
                                "get.LoyaltyExpense.LoyaltyId"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ConsumptionScore,
                                "text",
                                "get.LoyaltyExpense.SpentPoint"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TransactionDate,
                                "date",
                                "get.LoyaltyExpense.TransactionDate"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c62ba1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c62ba1d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoyaltyExpense/get.vue
// module id = null
// module chunks = 